import React from "react"
import { injectIntl } from "react-intl";
import CAMIF from "../images/Logo CAMIF.png"
import AMETIX from "../images/Logo AMETIX.png"
import BARTON from "../images/Logo BARTON.png"
import BREEGA from "../images/Logo BREEGA.png"
import CATHAY from "../images/Logo CATHAY.png"
import ENGIE from "../images/Logo ENGIE.png"
import AVOLTA from "../images/Logo AVOLTA.png"
import MAZARS from "../images/Logo MAZARS.png"
import BOLLORE from "../images/Logo BOLLORE.png"
import THEODO from "../images/Logo THEODO.png"


const Community = ({intl}) => (

    <section className="joinCm marginBottom116">
        <div className="container">
            <div className="row">
                <div className="col-md-12">
                    <h1 className="d-flex justify-content-center">{intl.formatMessage({id: "violetta.join_the_community"})}</h1>
                    <div className="mx-auto d-block col-11 d-md-none">
                        <marquee>
                            <img src={CAMIF} />
                            <img src={AMETIX} />
                            <img src={BARTON} />
                            <img src={BREEGA} />
                            <img src={CATHAY}/>
                            <img src={ENGIE} />
                            <img src={AVOLTA} />
                            <img src={MAZARS} />
                            <img src={BOLLORE} />
                            <img src={THEODO} />
                        </marquee>
                    </div>
                    <div className="mx-auto col-11 d-none d-md-block">
                        <img src={CAMIF} />
                        <img src={AMETIX} />
                        <img src={BARTON} />
                        <img src={BREEGA} />
                        <img src={CATHAY}/>
                        <img src={ENGIE} />
                        <img src={AVOLTA} />
                        <img src={MAZARS} />
                        <img src={BOLLORE} />
                        <img src={THEODO} />
                    </div>
                </div>
            </div>
        </div>
    </section>
)
export default injectIntl(Community);
